import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";

export default function LockScreen({ unlockTime }) {
  const [remaining, setRemaining] = useState();
  useEffect(() => {
    if (!unlockTime) return;

    const interval = setInterval(() => {
      const now = new Date();
      const target = new Date(unlockTime);

      const diff = target - now;

      if (diff <= 0) {
        setRemaining("");
        clearInterval(interval);
        return;
      }

      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      setRemaining(
        `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`,
      );
    }, 1000);

    return () => clearInterval(interval);
  }, [unlockTime]);

  return (
    <Box
      sx={{
        height: "60dvh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography variant="h5" sx={{ mb: 1 }}>
        🔒 Reservierungen sind aktuell gesperrt
      </Typography>

      <Typography variant="body2">Öffnet in:</Typography>

      <Typography variant="h4" sx={{ mt: 1 }}>
        {remaining || "--:--"}
      </Typography>

      <Typography variant="caption" sx={{ mt: 1 }}>
        Öffnet um:
        {unlockTime ? new Date(unlockTime).toLocaleString("de-CH") : "-"}
      </Typography>
    </Box>
  );
}
